module.exports = __webpack_public_path__ + "img/fast.e01b82fa.svg";